import { Link } from 'react-router-dom';
import { useI18n } from '@/hooks/useI18n';
import { useShell } from '@/hooks/useShell';
import { routes } from '@/lib/routes';

export const NewsTicker = () => {
  const { t } = useI18n();
  const { shell } = useShell();
  const urgent = shell?.urgent ?? [];

  const items =
    urgent.length > 0
      ? urgent.map((item) => ({ id: item.id, title: item.title, href: item.href || routes.requests }))
      : [
          { id: 'fallback-1', title: t('ticker.item1' as any), href: routes.requests },
          { id: 'fallback-2', title: t('ticker.item2' as any), href: routes.requests },
          { id: 'fallback-3', title: t('ticker.item3' as any), href: routes.requests },
        ];

  const loop = [...items, ...items];

  return (
    <div className="ticker-wrap">
      <div className="ticker-label">{t('ticker.label')}</div>
      <div className="ticker-window">
        <div className="ticker-track">
          {loop.map((item, index) => (
            <span key={`${item.id}-${index}`} aria-hidden={index >= items.length}>
              {item.title}
              <Link to={item.href} className="ticker-open">
                открыть
              </Link>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};
